// removed by extract-text-webpack-plugin
module.exports = {"container":"_37hf","wrapper":"_2XpH","ctaContainer":"_2lFj","imageContainer":"_1HLg","image":"_1Meg","ie":"ViKB","light":"_2ood"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/CaseStudiesPage/CaseStudySection/styles.scss
// module id = 520
// module chunks = 0